import { Avatar, IconButton } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import MicIcon from '@material-ui/icons/Mic';
import './Chat.css'
import { useParams, useHistory } from 'react-router-dom';
import db, { auth } from '../firebase';
import firebase from 'firebase';
import { useStateValue } from '../StateProvider';
import logo from './pratyushTitle.png';
import SidebarChat from './SidebarChat';

function Chat() {

    const [input, setInput] = useState('');
    const [seed, setSeed] = useState('');
    const { roomId } = useParams();
    const [roomName, setRoomName] = useState('');
    const [messages, setMessages] = useState([]);
    const [{ user }, dispatch] = useStateValue();
    const history = useHistory();
    const [rooms, setRooms] = useState([]);

    const handleAuthentication = () => {
        if (user) {
            auth.signOut();
            history.push('/');
        }
    }
    useEffect(() => {
        if (user) {
            db.collection('rooms').onSnapshot(snapshot => (
                setRooms(snapshot.docs.map(doc =>
                    ({
                        id: doc.id,
                        data: doc.data()
                    })
                ))
            ));
            // return () => {
            //     Unsubscribe();
            // }
        }
    }, []);

    useEffect(() => {
        if (roomId) {
            db.collection('rooms').doc(roomId).onSnapshot(snapshot => (
                setRoomName(snapshot.data().name)
            ));

            db.collection('rooms').doc(roomId).collection('messages').orderBy('timestamp', 'asc').onSnapshot(snapshot => {
                setMessages(snapshot.docs.map(doc => doc.data()))
            })
        }
    }, [roomId])

    useEffect(() => {
        setSeed(Math.floor(Math.random() * 5000));

    }, [roomId]);

    const sendMessage = (e) => {
        e.preventDefault();
        db.collection('rooms').doc(roomId).collection('messages').add({
            message: input,
            name: user.displayName,
            profile: user?.photoURL,
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        })

        setInput('')
    }

    return (

        <div className="chat">

            <div className="chat__header">


                <Avatar src={`https://avatars.dicebear.com/api/human/${seed}.svg`} />
                {roomId ?
                    <div className="chat__headerInfo">
                        <h3>{roomName}</h3>
                        <p>Last Seen:
                        {new Date(
                            messages[messages.length - 1]?.timestamp?.toDate()).toUTCString()
                            }
                        </p>
                    </div> : <p className='chat__headerInfo'>Enter Any Grops from side bar to start chat</p>}



                <div className="chat__headerRight">
                    <IconButton>
                        <SearchOutlinedIcon />
                    </IconButton>
                    <IconButton>
                        <AttachFileIcon />
                    </IconButton>
                    <div class="dropdown">
                        {/* <button class="dropbtn">Dropdown</button> */}
                        <IconButton>
                            <MoreVertIcon />
                        </IconButton>
                        <div class="dropdown-content">
                            <div className='mobile__content'>
                                {rooms.map(room => (
                                    <SidebarChat
                                        key={room.id}
                                        id={room.id}
                                        name={room.data.name}
                                    />
                                ))}
                            </div>

                            <p onClick={handleAuthentication}>Log-Out</p>

                        </div>
                    </div>
                </div>
            </div>
            {roomId ?
                <div className="chat__body">

                    {messages.map(message => (
                        <p className={`chat__message ${message.name === user.displayName && 'chat__reciver'}`}>
                            <Avatar className='chat__profile' src={message.profile} />
                            <span className="chat__name">
                                {message.name}
                            </span>
                            {message.message}
                            <span className="chat__timestamp">
                                {new Date(message.timestamp?.toDate()).toUTCString()}
                            </span>
                        </p>

                    ))}

                </div>
                : <div className='chat__body'> Hyy, Welcome to the community
                <img
                        src={logo}
                        alt="Login__Logo"
                    /></div>}
            {roomId &&
                <div className="chat__footer">
                    <InsertEmoticonIcon />
                    <form>
                        <input
                            type="text"
                            value={input}
                            onChange={e => setInput(e.target.value)}
                            placeholder="Type a message " />
                        <button type="submit" onClick={sendMessage}>Send a Message</button>
                    </form>
                    <MicIcon />
                </div>
            }

        </div>
    )
}

export default Chat
